import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class RefreshTokenStateService {
  private readonly _refreshTokenInProgress$ = new BehaviorSubject<boolean>(
    false
  );

  get refreshTokenInProgress$(): Observable<boolean> {
    return this._refreshTokenInProgress$.asObservable();
  }

  get refreshTokenInProgress(): boolean {
    return this._refreshTokenInProgress$.getValue();
  }

  setRefreshTokenInProgress(state: boolean): void {
    this._refreshTokenInProgress$.next(state);
  }
}
